import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, $insertNodes } from 'lexical';
import { useEffect, useRef } from 'react';

export function OnChangePlugin({
  value,
  onChange,
}: {
  value?: string;
  onChange?: (html: string) => void;
}) {
  const [editor] = useLexicalComposerContext();
  const prev = useRef<string | undefined>(value);

  useEffect(() => {
    if (editor && value) {
      editor.update(() => {
        const parser = new DOMParser();
        const dom = parser.parseFromString(value, 'text/html');
        const nodes = $generateNodesFromDOM(editor, dom);
        $getRoot().clear();
        $insertNodes(nodes);
      });
    }
  }, [editor, value]);

  useEffect(
    () =>
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const htmlString = $generateHtmlFromNodes(editor);
          if (prev.current === htmlString) return;

          onChange?.(
            htmlString === '<p class="editor-paragraph"><br></p>'
              ? ''
              : htmlString
          );
          prev.current = htmlString;
        });
      }),
    [editor, onChange]
  );

  return null;
}
